<template>
  <div>
    <p
      v-if="document.data && document.data.duplicatedDataValidation === false"
      class="text-danger font-larger font-weight-bold"
    >
      <span>
        Uwaga: Wniosek z takimi danymi został już złożony. W przypadku konieczności edycji proszę o kontakt&nbsp;
      </span>

      <span v-if="submitToSchool">ze&nbsp;szkołą.</span>

      <span v-else>z&nbsp;Wydziałem Oświaty i&nbsp;Wychowania UM.</span>
    </p>

    <p v-if="errors" class="text-danger font-larger font-weight-bold">
      {{ errors }}
    </p>

    <w-input
      class="form-group"
      :model="schema.mdokId"
      @input="loadDocumentName(schema.mdokId.$model, 'mdok/getDocumentNameAndIncomeDate')"
    />

    <div v-if="documentName && schema.mdokId.$model" class="form-group">
      Wybrano dokument: <b>{{ documentName }}</b>
    </div>

    <w-datepicker v-if="!hasDeliveryDate" class="form-group" :model="schema.deliveryDate" />

    <w-input class="form-group" :model="schema.epuapAddress" />

    <w-radio-list :values="values" :model="schema.confirmedDocument.CONFIRMED_SIGNED.passed" />

    <w-radio-list class="mt-4" :values="values" :model="schema.confirmedDocument.CONFIRMED_COMPLETED.passed" />

    <w-radio-list class="mt-4" :values="values" :model="schema.confirmedDocument.CONFIRMED_ATTACHMENTS.passed" />

    <yes-or-no-radio class="mt-4" :model="schema.confirmedDocument.IS_UKRAINE.bool" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
import { mapState } from 'vuex';

import { mdokDocumentMixin } from '@/mixins/mdokDocument';

import YesOrNoRadio from '../document/YesOrNoRadio.vue';

// @vuese
// Formularz uzasadnienia
// @group ActionData
export default {
  components: { ...components, YesOrNoRadio },
  mixins: [mdokDocumentMixin],
  props: {
    // schema
    schema: { type: Object, required: true },
    // dokument
    selectedDocument: { type: Object, required: false }
  },
  data() {
    return {
      values: [
        { value: 1, text: 'Tak' },
        { value: 3, text: 'Nie' }
      ]
    };
  },
  computed: {
    ...mapState({
      storedDocument: state => state.documentIndex?.data
    }),
    errors() {
      return this.document?.data?.veryImportantErrors;
    },
    document() {
      return this.selectedDocument || this.storedDocument;
    },
    hasDeliveryDate() {
      return !!this.document.values?.DELIVERY_DATE;
    },
    submitToSchool() {
      return this.document.data?.school?.financingType === 1;
    }
  },

  methods: {
    // Ustawia pobraną datę
    afterNameGet(data) {
      const contact = data?.contact?.replace(/@epuap\d?/i, '');

      this.schema.deliveryDate?.$setData(data?.date || undefined);
      this.schema.epuapAddress?.$setData(contact || undefined);
    }
  }
};
</script>
